<div class="flex flex-col request-deploy-instance-dialog h-100-percent">
  <app-sidenav-header [title]="title" [subtitle]="subtitle"></app-sidenav-header>

  <div class="flex flex-col overflow-y-auto mb-20">
    <app-deploy-instance-form #deployInstanceForm [deployment]="deployment" [service]="service"></app-deploy-instance-form>

    <form [formGroup]="requestForm" class="mr-20">
      <div class="flex flex-col form-field form-field-lg-1">
        <label>{{'INSTANCE_SUMMARY.CREATE_DEVELOPMENT_INSTANCE.REQUEST_DESCRIPTION' | transloco | uppercase}}</label>
        <textarea class="p-10" formControlName="requestDescription" required>
        </textarea>
        <div class="flex flex-row justify-between">
          <app-error [control]="requestForm.get('requestDescription')"></app-error>
        </div>
      </div>
    </form>
  </div>

  <mat-divider class="mb-32"></mat-divider>

  <div class="flex flex-row gap-x-4" dir="rtl">
    <button class="accent" type="button" (click)="requestDeployment()">{{'BUTTONS.REQUEST' | transloco}}</button>
    <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}
    </button>
  </div>
</div>
